// extracted by mini-css-extract-plugin
module.exports = {"content":"ProductInfo_content__3y2hv","modal":"ProductInfo_modal__Zpaa3","field":"ProductInfo_field__cxstN","footer":"ProductInfo_footer__3wxAg"};